import React from 'react';

const Loader = () => {
  const baseColor = '#8BC34A';
  const totalDots = 12;

  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f5f5f5',
        flexDirection: 'column',
        color: '#555',
        fontSize: '1.2rem',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <div style={{ position: 'relative', width: 60, height: 60, marginBottom: 20 }}>
        {Array.from({ length: totalDots }).map((_, i) => {
          const angle = (i * 30) * (Math.PI / 180); 
          const radius = 22;
          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);
          const opacity = (i + 1) / totalDots; 

          return (
            <div
              key={i}
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                width: 10,
                height: 10,
                margin: -5,
                borderRadius: '50%',
                backgroundColor: baseColor,
                transform: `translate(${x}px, ${y}px)`,
                opacity: opacity,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Loader;
